import { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";

export interface SupportTicketNotificationRef {
  supportTicketId: string;
}

export interface SupportTicketPresenceRef extends SupportTicketNotificationRef {
  userId: string;
}

export function notificationSupportTicketId(
  event: SupportTicketNotificationRef,
): SupportTicketId {
  return SupportTicketId.make(event.supportTicketId);
}

export function supportTicketPresenceKey(
  event: SupportTicketPresenceRef,
): string {
  return `${event.supportTicketId}:${event.userId}`;
}
